import { Logo } from "../../components/ui.jsx";

export function ActionLink({ href, children, variant = "secondary", className = "" }) {
  const variants = {
    primary: "border-transparent bg-primary text-white shadow-[0_1px_2px_oklch(0_0_0_/_0.08)] hover:bg-primary-600",
    secondary: "border-border text-foreground hover:border-muted-foreground hover:bg-muted",
    ghost: "border-transparent text-muted-foreground hover:text-foreground",
  };
  return <a className={`inline-flex min-h-10 items-center justify-center rounded-lg border px-4 text-[13px] font-bold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${variants[variant]} ${className}`} href={href}>{children}</a>;
}

const HOME_SECTIONS = [
  ["#agents", "Agents"],
  ["#mcp", "MCP"],
  ["#platform", "Platform"],
  ["#controls", "Controls"],
];

export function PublicHeader({ actor, current = "home" }) {
  return (
    <header className="mx-auto flex min-h-20 w-full max-w-[1440px] items-center justify-between gap-6 border-b border-neutral-100 px-5 sm:px-8 lg:px-12">
      <div className="flex items-center gap-10">
        <a className="focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary" href="/" aria-label="RevPal home"><Logo /></a>
        {current === "home" && (
          <nav className="flex items-center gap-6 max-lg:hidden" aria-label="Page sections">
            {HOME_SECTIONS.map(([href, label]) => (
              <a className="text-[13px] font-medium text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary" href={href} key={href}>{label}</a>
            ))}
          </nav>
        )}
      </div>
      <nav className="flex items-center gap-1" aria-label="Public navigation">
        {actor ? (
          <ActionLink href="/app" variant="primary">Open workspace</ActionLink>
        ) : current === "signup" ? (
          <ActionLink href="/login" variant="secondary">Sign in</ActionLink>
        ) : current === "login" ? (
          <ActionLink href="/signup" variant="primary">Create account</ActionLink>
        ) : (
          <>
            <ActionLink href="/login" variant="ghost" className="max-sm:hidden">Sign in</ActionLink>
            <ActionLink href="/signup" variant="primary">Create account</ActionLink>
          </>
        )}
      </nav>
    </header>
  );
}

const FOOTER_COLUMNS = [
  ["Product", [
    ["/#agents", "Agents at work"],
    ["/#mcp", "MCP integration"],
    ["/#platform", "Platform"],
    ["/#use-cases", "Use cases"],
  ]],
  ["Trust", [
    ["/#controls", "The control plane"],
    ["/#controls", "Agent audit"],
    ["/#controls", "Approval-gated outreach"],
  ]],
  ["Get started", [
    ["/signup", "Create account"],
    ["/login", "Sign in"],
    ["/app", "Open workspace"],
  ]],
];

export function PublicFooter() {
  return (
    <footer className="border-t border-neutral-100">
      <div className="mx-auto grid w-full max-w-[1440px] gap-12 px-5 py-14 sm:px-8 lg:grid-cols-[1.2fr_repeat(3,minmax(0,.6fr))] lg:px-12">
        <div className="grid content-start justify-items-start gap-4">
          <Logo />
          <p className="max-w-[34ch] text-[13px] leading-6 text-muted-foreground">The agent-driven revenue workspace. Canonical records, scoped agent access over MCP, and a person at every decision that matters.</p>
          <p className="font-mono text-[10px] uppercase tracking-[.12em] text-muted-foreground">Cloudflare Workers · D1 · MCP</p>
        </div>
        {FOOTER_COLUMNS.map(([title, links]) => (
          <nav className="grid content-start gap-3" aria-label={`Footer ${title}`} key={title}>
            <span className="text-[11px] font-bold uppercase tracking-[.1em] text-muted-foreground">{title}</span>
            {links.map(([href, label]) => (
              <a className="text-[13px] text-neutral-600 transition-colors hover:text-foreground" href={href} key={`${href}-${label}`}>{label}</a>
            ))}
          </nav>
        ))}
      </div>
      <div className="mx-auto flex w-full max-w-[1440px] flex-wrap items-center justify-between gap-4 border-t border-neutral-100 px-5 py-6 text-xs text-muted-foreground sm:px-8 lg:px-12">
        <span>RevPal · Durable revenue memory for people and agents.</span>
        <span className="font-mono text-[10px] uppercase tracking-[.12em]">agents work · people decide</span>
      </div>
    </footer>
  );
}
